import type { ReactNode } from 'react';
import { ListStyle } from 'is24-corecss';

export const Benefits = ({
  sections,
}: {
  sections: Record<string, { title: ReactNode; items: Record<string, ReactNode> }>;
}) => (
  <>
    {Object.entries(sections).map(([key, { title, items }]) => (
      <section key={key} className='margin-bottom-l'>
        <h3 className='font-body-medium-bold margin-bottom-s'>{title}</h3>
        <ListStyle variant='checkmark' className='list-spacing-s'>
          {Object.entries(items).map(([id, content]) => (
            <ListStyle.Item key={id}>{content}</ListStyle.Item>
          ))}
        </ListStyle>
      </section>
    ))}
  </>
);
